import TableViewIcon from '@mui/icons-material/TableView'
const Icon = () => {
  return (
    <TableViewIcon
      htmlColor='#E62E30'
      fontSize='large'
    />
  )
}

export default Icon
